import styled from 'styled-components';
import { GenericSvg } from '../../assets/svgs/GenericSVG';
import { colors } from '../../styles/colors';
import { useHandleDocumentDownload } from './utils/useHandleDocumentDownload';

const BLUE = '#1e3542';
const CYAN = '#00b8e1';
const CYAN_DARK = '#0090b3';
const MUTED = '#5b6b74';
const LINE = '#e4e9ec';
const PAGE_BG = '#f4f7f8';
const INFO_BG = '#eefafd';
const SUCCESS_BG = '#eaf6ee';
const SUCCESS_TEXT = '#1d6b3a';
const SUCCESS_LINE = '#2f9e5a';
const ERROR_BG = '#fdecea';
const ERROR_TEXT = '#a5342f';
const ERROR_LINE = colors.lightRed;

export const DocumentDownload = () => {
  const { downloadStatus, errorMessage, downloadAttempted, retryDownload, canRetry } = useHandleDocumentDownload();

  const isError = downloadStatus === 'ERROR' || downloadStatus === 'MISSING_PARAMS';

  return (
    <Page>
      <Card>
        <LogoWrapper>
          <GenericSvg name="Logo" height={34} primaryColor={colors.dark} />
        </LogoWrapper>

        <Title>Dokumentenservice</Title>
        <Paragraph>
          Willkommen beim Dokumentenservice von Physiofit. Diese Seite dient ausschließlich dem sicheren Abruf Ihrer
          Dokumente.
        </Paragraph>

        {!isError && (
          <InfoBox>
            <strong>Hinweis:</strong> Ihr Dokument wird automatisch heruntergeladen. Falls der Download nicht startet,
            prüfen Sie bitte, ob Ihr Browser Popups für diese Seite blockiert, oder nutzen Sie den Button unten.
          </InfoBox>
        )}

        {canRetry && <DownloadButton onClick={retryDownload}>Dokument herunterladen</DownloadButton>}

        {downloadStatus === 'SUCCESS' && (
          <StatusBox>
            {downloadAttempted
              ? 'Ihr Dokument wurde erfolgreich heruntergeladen.'
              : 'Ihr Dokument wurde erfolgreich verarbeitet.'}
          </StatusBox>
        )}

        {isError && (
          <ErrorBox>
            <strong>{downloadStatus === 'MISSING_PARAMS' ? 'Ungültige URL: ' : 'Fehler beim Herunterladen: '}</strong>
            {errorMessage ||
              'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support.'}
          </ErrorBox>
        )}

        <Foot>
          <FootTitle>Haben Sie Fragen?</FootTitle>
          <FootText>
            Bei Fragen oder Problemen erreichen Sie uns unter{' '}
            <a href="mailto:service@physiofit.app">service@physiofit.app</a>.
          </FootText>
          <FootText>Physiofit Digital GmbH · Agnes-Pockels-Bogen 1, 80992 München</FootText>
        </Foot>
      </Card>
    </Page>
  );
};

const Page = styled.div`
  min-height: 100vh;
  background: ${PAGE_BG};
  padding: 24px;
  color: ${BLUE};
  line-height: 1.55;
`;

const Card = styled.div`
  background: ${colors.white};
  max-width: 640px;
  margin: 0 auto;
  border: 1px solid ${LINE};
  border-radius: 12px;
  padding: 32px 36px;

  @media (max-width: 520px) {
    padding: 24px 20px;
  }
`;

const LogoWrapper = styled.div`
  margin-bottom: 24px;
  padding-left: 8px;
  svg {
    display: block;
    height: 24px;
    width: auto;
  }
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 8px;
  color: ${BLUE};
`;

const Paragraph = styled.p`
  margin: 12px 0;
  color: ${BLUE};
`;

const InfoBox = styled.div`
  background: ${INFO_BG};
  border-left: 3px solid ${CYAN};
  border-radius: 6px;
  padding: 14px 16px;
  margin: 20px 0;
  font-size: 15px;
  color: ${BLUE};
`;

const DownloadButton = styled.button`
  background: ${CYAN};
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  padding: 13px 22px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: inline-block;
  margin-top: 12px;
  font-family: inherit;

  &:hover {
    background: ${CYAN_DARK};
  }
`;

const StatusBox = styled.div`
  margin-top: 18px;
  padding: 12px 16px;
  border-radius: 6px;
  background: ${SUCCESS_BG};
  color: ${SUCCESS_TEXT};
  border-left: 3px solid ${SUCCESS_LINE};
  font-size: 15px;
`;

const ErrorBox = styled.div`
  margin-top: 18px;
  padding: 12px 16px;
  border-radius: 6px;
  background: ${ERROR_BG};
  color: ${ERROR_TEXT};
  border-left: 3px solid ${ERROR_LINE};
  font-size: 15px;
`;

const Foot = styled.div`
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid ${LINE};
  font-size: 14px;
  color: ${MUTED};
`;

const FootTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: ${BLUE};
  margin: 0 0 4px;
`;

const FootText = styled.p`
  margin: 12px 0;
  color: ${MUTED};

  a {
    color: ${CYAN_DARK};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
